import { useContext, useEffect, useState } from "react";
// import LeftPanelImage from "app/uicomponents/microcomponents/LeftPanelImage";
import { ContactLeftPanelV2Items } from "app/Data/ContactLeftPanelItems";
import ContactLeftPanelMenuItem from "app/uicomponents/microcomponents/ContactLeftPanelMenuItem";
// import LeftPanelUserDetails from "app/uicomponents/microcomponents/LeftPanelUserDetails";
import DarkModeSelection from "../features/dashboard/components/DarkModeSelection";
import SignoutLeftPanel from "app/uicomponents/microcomponents/SignoutLeftPanel";
// import { Skeleton } from "primereact/skeleton";
import { updatePanelItems } from "app/utils/utils";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";
import LeftPanelBrandingLogo from "app/uicomponents/microcomponents/LeftPanelBrandingLogo";
import { getObjectFromSessionStore, setObjectInSessionStore } from "app/utils/sessionStore";
import { makeRequest } from "app/utils/makeRequest";
import { Tooltip } from "primereact/tooltip";
import HexagonAvatar from "../features/dashboard/components/HeaxagonImage";
import { useNavigate } from "react-router-dom";

const ContactLeftPanel = () => {
  const { contactProfilePic, isOpen, setIsOpen } = useContext(ContactProfileDetailsContext);
  const propStats = getObjectFromSessionStore("proposalStats");
  const [proposalStats, setProposalStats] = useState<any>(propStats ?? {});
  const navigate = useNavigate();

  const updateProposalStats = () => {
    makeRequest("proposalStats")
      .get()
      .then((res) => {
        setProposalStats(res.data.data ?? {});
        setObjectInSessionStore("proposalStats", res.data.data ?? {});
      });
  };

  useEffect(() => {
    updateProposalStats();
  }, []);

  const ContactLeftPanelItemsUpdated = updatePanelItems(ContactLeftPanelV2Items, proposalStats);

  return (
    <div className={`mb-4 relative z-[100] ${isOpen ? "w-[10.5rem]" : "w-[7.75rem]"}`}>
      <aside className="h-[100vh] fixed z-100" style={{ width: isOpen ? "10.5rem" : "7.75rem" }}>
        <nav
          className={`scrollbar-hide h-full flex flex-col justify-content-between overflow-y-auto pt-3 pb-4 dark:bg-blue-1100 ${
            isOpen ? "px-2" : "px-3"
          }`}
          style={{
            scrollbarWidth: "thin",
          }}
        >
          <div>
            <div className="absolute group right-[-18px] top-2 pb-2 flex justify-between items-center">
              <button
                type="button"
                onClick={() => {
                  setIsOpen((prev: any) => !prev);
                }}
                className="flex items-center justify-center bg-transparent border-none p-0 cursor-pointer"
              >
                {isOpen ? (
                  <i
                    className="left-angles pi pi-angle-double-left"
                    style={{
                      fontSize: "1.2rem",
                      color: "#3B82F6",
                      marginTop: "49px",
                    }}
                    data-pr-tooltip="Collapse"
                  >
                    <Tooltip target=".left-angles" className="tooltip-wrapper" />
                  </i>
                ) : (
                  <i
                    className="right-angles pi pi-angle-double-right"
                    style={{
                      fontSize: "1.2rem",
                      color: "#3B82F6",
                      marginTop: "49px",
                    }}
                    data-pr-tooltip="Expand"
                  >
                    <Tooltip target=".right-angles" className="tooltip-wrapper" />
                  </i>
                )}
              </button>
            </div>
            <LeftPanelBrandingLogo />
            {/* <LeftPanelImage /> */}
            {/* <h4
              className={`text-xl font-semibold !text-grayTexttext-center my-3 transition-opacity ${
                isOpen ? "opacity-100" : "opacity-0 hidden"
              }`}
            >
              {contactFirstName || contactLastName ? (
                `${contactFirstName} ${contactLastName}`
              ) : (
                <Skeleton width="100%" height="3rem" borderRadius="16px" className="mb-2" />
              )}
            </h4>
            <div className="mt-4 mb-6 flex justify-center">
              <div
                className={`${isOpen ? "w-full" : "!w-[3.5rem]"} h-[1px] bg-gray-500 rounded-md `}
              />
            </div> */}
            <div className="flex justify-center items-center">
              <ul className={`leftPanelUl flex-1 text-center mb-3 ${!isOpen ? "w-[36px]" : ""}`}>
                {ContactLeftPanelItemsUpdated.map(
                  (item: any) =>
                    !item.hide && (
                      <ContactLeftPanelMenuItem
                        key={item.id}
                        directTo={item.key}
                        name={item.name}
                        icon={item.icon}
                      />
                    ),
                )}
              </ul>
            </div>
          </div>
          <div className="flex-grow">
            <DarkModeSelection />
            <div
              className="w-full flex justify-center items-center my-4 cursor-pointer"
              onClick={() => navigate("/agent/contact/profile")}
            >
              <HexagonAvatar imageUrl={contactProfilePic} size={72} />
            </div>
            <div className="w-full flex justify-center items-center">
              <SignoutLeftPanel />
            </div>
          </div>
        </nav>
      </aside>
    </div>
  );
};

export default ContactLeftPanel;
